import ModalService from "src/core/common/services/modalService";

export default new ModalService();
